var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"px-3"},[_c('MealSetRegister')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }